module.exports = __webpack_public_path__ + "static/img/connection_waiting.17307fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/connections/connection_waiting.png
// module id = vVsg
// module chunks = 31